import { FETCH_ALL, FETCH_ONE,BILLING_LIST } from "../stores/action-types";
import { HMIS_PATIENT_ID } from "@/plugins/vars";
import http from "@/http";

export default {
    // module assets
    namespaced: true,
    state: {
        item: {},
        items: [],
        billingpatients:[]
     },

    getters: {

        [FETCH_ONE]: state => {

            return state.item;
        },
        [BILLING_LIST]: state=> {
            return state.billingpatients;
        }
    },

    actions: {

        [FETCH_ALL] ({commit}, items) {

           commit(FETCH_ALL, items);
        },

        [FETCH_ONE] ({commit}) {
            if(!window.Cookies.get(HMIS_PATIENT_ID)) return Promise.reject('Kindly select patient before proceeding.');

            return new Promise((resolve, reject) => {
                http.get(`PatientRegistration/GetSpecificPatient?PatientID=${window.Cookies.get(HMIS_PATIENT_ID)}`).then(response => {
                    resolve(commit(FETCH_ONE, response.data.length ? response.data[0]: {}));
                }).catch(() => {
                    reject(null);
                });
            });
        },

        setPatient({commit}, item) {
            commit(FETCH_ONE, item);
        },
        setBillingPatients({commit},billingpatients){
            commit(BILLING_LIST,billingpatients);
        }
    },

    mutations: {

        [FETCH_ALL] (state, items) {

            state.items = items;
        },

        [FETCH_ONE] (state, item) {
            
            state.item  = item;
        },
        [BILLING_LIST] (state,billingpatients){
            state.billingpatients=billingpatients;
        }
    },
}
